module.exports = __webpack_public_path__ + "img/tedian.0914d674.png";